import { render, staticRenderFns } from "./Movements.vue?vue&type=template&id=dd2ba454&scoped=true"
import script from "./Movements.vue?vue&type=script&lang=js"
export * from "./Movements.vue?vue&type=script&lang=js"
import style0 from "./Movements.vue?vue&type=style&index=0&id=dd2ba454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2ba454",
  null
  
)

export default component.exports